import React, { Fragment, useEffect } from 'react'
import Slider from "../../../../hoc/SliderContainer"
import { withRouter } from "react-router-dom";
import { Typography, Grid } from '@material-ui/core';
import { useSelector } from "react-redux";
import { Translate } from "../../../../utils/Translate";
import LoadingClassesShimmer from "../../../../components/Shimmer/LoadingClassesShimmer";
import { useBrowseCollections } from "../../../../hooks/useBrowseCollections"

const BrowseCollections = (props) => {
    const { useBrowseCollectionsDispatch } = useBrowseCollections()
    const { fetchOnDemandClasses } = useBrowseCollectionsDispatch()
    const userId = localStorage.getItem("userId");

    const collectionArray = useSelector(state => state.onDemand.onDemandCollection)

    useEffect(() => {
        fetchOnDemandClasses(userId ? userId : "")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Fragment>

            <Grid container id='channelBg'>
                <div className="fixedWidthContainer container channelbg-banner">
                    {
                        <div className="bg-placeholder">
                            <div className="fallbackBox" />
                            <img src={require("../../../../assets/images/collection-banner.jpg")} className="bg-banner" alt='collection' />
                        </div>
                    }

                    <div className="overlay banner-overlay text-center">
                        <div style={{ zIndex: 1 }} className="centeredText text-white">
                            <Typography variant="h1" className="m-t-xs-5">
                                {Translate({ id: "ClassListViews.Collections" })}
                            </Typography>
                            <Grid container direction="row">
                                <Grid item lg={12} md={12} className="text-center channelDescription hidden-xs">
                                    <Typography className="padding16" variant="h6" >
                                        {Translate({ id: "ClassListViews.CollectionDescription" })}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </div>
                <div className="page-container hidden-lg">
                    <Grid container direction="row">
                        <Grid item lg={12} md={12} xs={12} sm={12} className="text-center channelDescription text-gray m-t-xs-5">
                            <Typography variant="h6" >
                                {Translate({ id: "ClassListViews.CollectionDescription" })}
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
            </Grid>
            <div className="page-container collection-list collectionPage">
                {collectionArray ? (collectionArray.length > 0 && collectionArray.map(
                    collection => (
                        (collection.collectionName && collection.collectionName.toLowerCase() !== "favourites") &&
                        (collection.collectionType.toLowerCase() !== "classoftheday") && collection.collectionItems && collection.collectionItems.length > 0 &&
                        <Slider
                            key={collection.collectionTag}
                            collectionTag={collection.collectionTag}
                            collectionName={collection.collectionName}
                            items={collection.collectionItems}
                            description={collection.description}
                        />
                    ))) :

                    <LoadingClassesShimmer />}
            </div>
        </Fragment>
    )
}

export default withRouter(BrowseCollections);

